module.exports = __webpack_public_path__ + "img/bf.025e429e.png";